import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { AxiosError } from 'axios';
import { classToPlain, plainToClass } from 'class-transformer';
import { API_PATH } from '../models/Constants';
import { ProgressContract } from '../models/Contract';
import { BudgetComponentsM6P1Row, BudgetComponentsResponse, BudgetComponentsResponseM6P1, BudgetComponentsRow, BudgetProgress, FinalRemarks, MeasureSpecificTargetsM1P1, MeasureSpecificTargetsM4P1, MeasureSpecificTargetsM4P2, MeasureSpecificTargetsM4P3Road, MeasureSpecificTargetsM4P3Roads, MeasureSpecificTargetsM4P3Water, MeasureSpecificTargetsM4P4, MeasureSpecificTargetsM6P1, ProjectStatusUpdate } from '../models/PPR';
// import { sample } from "lodash"

export default class PPRApi {
    private http: HTTPClient;
    private static instance: PPRApi | null = null;

    private constructor(http: HTTPClient) {
        this.http = http;
    }

    public static getInstance(http: HTTPClient): PPRApi {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new PPRApi(http);
        return this.instance;
    }

    async getProgressContract(subjectId: string, contractId: string, applicationId: string): Promise<[ProgressContract | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const dataMock = plainToClass(ProgressContract, {
            //     "subject_id": 954080,
            //     "application_id": 220029,
            //     "contract_id": 19212,
            //     "project_app_id": 220029,
            //     "contract_code": "19212/190726/2017",
            //     "identification_code": "19212/190726/2017",
            //     "description": null,
            //     "project_title": "PARTICIPATION IN THE RURAL DEVELOPMENT COMMITTEE MEETING TO BE HELD ON THE 14TH OF JUNE 2017 ",
            //     "status": "WITHDRAWN",
            //     "cod_modu": "M06.1", // "M01.1" or "M04.1" or "M04.2" or "M04.3" or "M04.4" or "M06.1"
            //     "type_modu": "water",
            //     "measure": "CHANGE REQUEST APPLICATION",
            //     "proj_dt_start": 1653914252674,
            //     "proj_dt_end": 1653914252674,
            //     "total_pub_elig_amount": 660.0,
            //     "pub_elig": 660.0,
            //     "priv_share": 1653914252674,
            //     "total_proj_cost": 1653914252674,
            //     "can_edit": 1,
            //     "paths": {
            //         "budget-components": 1,
            //         "budget-components-m6-p1": 1,
            //         "budget-progress": 1,
            //         "final-remarks": 1,
            //         "measure-specific-targets-m1-p1": 1,
            //         "measure-specific-targets-m4-p1": 1,
            //         "measure-specific-targets-m4-p2": 1,
            //         "measure-specific-targets-m4-p3-roads": 1,
            //         "measure-specific-targets-m4-p3-water": 1,
            //         "measure-specific-targets-m4-p4": 1,
            //         "measure-specific-targets-m6-p1": 1,
            //         "project-status-update": 1,
            //     }
            // });
            // resolve([dataMock, null]);

            this.http.get<ProgressContract>(`${API_PATH}/progress/contract/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(ProgressContract, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setProgressContract(subjectId: string, contractId: string, applicationId: string): Promise<[boolean | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<boolean>(`${API_PATH}/progress/submit/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async getProgressBudgetComponents(subjectId: string, contractId: string, applicationId: string): Promise<[BudgetComponentsResponse | null, AxiosError | null]> {
        return new Promise((resolve) => {

            // MOCK DATAS
            // const dataMock = plainToClass(BudgetComponentsResponse, {
            //     rows: [
            //         {
            //             actual_expenditure: 3.14,
            //             cost_budgeted: 3.14,
            //             cost_expenditure: 3.14,
            //             id_line_item: 3.14,
            //             type_description: "type_description",
            //             remarks: "remarks",
            //             upload_urls: [],
            //             file_ids: []
            //         },
            //         {
            //             cost_budgeted: 3.14,
            //             cost_expenditure: 3.14,
            //             id_line_item: 3.14,
            //             type_description: "type_description 2",
            //             upload_urls: [],
            //             file_ids: []
            //         },
            //     ],
            //     totals: {
            //         total_claim_advanced: 3.141592653589793,
            //         total_claim_others: 3.141592653589793,
            //         total_claim_both: 3.141592653589793,
            //     }
            // });
            // resolve([dataMock, null]);

            this.http.get<BudgetComponentsResponse>(`${API_PATH}/progress/budget-components/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(BudgetComponentsResponse, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @param data
     * @returns
     */
    async setProgressBudgetComponents(subjectId: string, contractId: string, applicationId: string, data: BudgetComponentsRow[]): Promise<[BudgetComponentsResponse | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<BudgetComponentsResponse>(`${API_PATH}/progress/budget-components/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(BudgetComponentsResponse, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * TODO: fix this with APIs
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressBudgetComponentsM6P1(subjectId: string, contractId: string, applicationId: string): Promise<[BudgetComponentsResponseM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const dataMock = plainToClass(BudgetComponentsResponseM6P1, {
            //     rows: [
            //         {
            //             actual_expenditure: 3.14,
            //             file_ids: [],
            //             type_description: 3.14,
            //             upload_urls: [],
            //             remarks: "remarks"

            //         }
            //     ],
            //     totals: {}
            // });
            // resolve([dataMock, null]);

            this.http.get<BudgetComponentsResponseM6P1>(`${API_PATH}/progress/budget-components-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(BudgetComponentsResponseM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setProgressBudgetComponentsM6P1(subjectId: string, contractId: string, applicationId: string, data: BudgetComponentsM6P1Row[]): Promise<[BudgetComponentsResponseM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<BudgetComponentsResponseM6P1>(`${API_PATH}/progress/budget-components-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(BudgetComponentsResponseM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * TODO: fix this with APIs
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressBudgetProgress(subjectId: string, contractId: string, applicationId: string): Promise<[BudgetProgress | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<BudgetProgress>(`${API_PATH}/progress/budget-progress/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(BudgetProgress, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setProgressBudgetProgress(subjectId: string, contractId: string, applicationId: string, data: BudgetProgress): Promise<[BudgetProgress | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<BudgetProgress>(`${API_PATH}/progress/budget-progress/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(BudgetProgress, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressProjectStatusUpdate(subjectId: string, contractId: string, applicationId: string): Promise<[ProjectStatusUpdate | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<ProjectStatusUpdate>(`${API_PATH}/progress/project-status-update/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(ProjectStatusUpdate, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setProgressProjectStatusUpdate(subjectId: string, contractId: string, applicationId: string, data: ProjectStatusUpdate): Promise<[ProjectStatusUpdate | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<ProjectStatusUpdate>(`${API_PATH}/progress/project-status-update/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(ProjectStatusUpdate, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM1P1(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM1P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM1P1>(`${API_PATH}/progress/measure-specific-targets-m1-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM1P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM1P1(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM1P1): Promise<[MeasureSpecificTargetsM1P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM1P1>(`${API_PATH}/progress/measure-specific-targets-m1-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM1P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM4P3Water(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM4P3Water | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM4P3Water>(`${API_PATH}/progress/measure-specific-targets-m4-p3-water/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P3Water, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM4P3Water(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM4P3Water): Promise<[MeasureSpecificTargetsM4P3Water | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM4P3Water>(`${API_PATH}/progress/measure-specific-targets-m4-p3-water/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P3Water, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM4P3Roads(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM4P3Roads | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // MOCK DATAS
            // const dataMock = plainToClass(MeasureSpecificTargetsM4P3Roads, {
            //     rows: [
            //         {
            //             ds_road: "ciao 1",
            //             year1: 2021,
            //             year2: 2022,
            //             year3: 2023,
            //             year4: 2024,
            //             year5: 2025,
            //         },
            //     ],
            //     years: {
            //         year1: 2021,
            //         year2: 2022,
            //         year3: 2023,
            //         year4: 2024,
            //         year5: 2025,
            //     }
            // })
            // resolve([dataMock, null]);

            this.http.get<MeasureSpecificTargetsM4P3Roads>(`${API_PATH}/progress/measure-specific-targets-m4-p3-roads/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P3Roads, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM4P3Roads(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM4P3Road[]): Promise<[MeasureSpecificTargetsM4P3Roads | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM4P3Roads>(`${API_PATH}/progress/measure-specific-targets-m4-p3-roads/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P3Roads, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM4P1(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM4P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM4P1>(`${API_PATH}/progress/measure-specific-targets-m4-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM4P1(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM4P1): Promise<[MeasureSpecificTargetsM4P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM4P1>(`${API_PATH}/progress/measure-specific-targets-m4-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM4P2(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM4P2 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM4P2>(`${API_PATH}/progress/measure-specific-targets-m4-p2/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P2, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM4P2(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM4P2): Promise<[MeasureSpecificTargetsM4P2 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM4P2>(`${API_PATH}/progress/measure-specific-targets-m4-p2/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P2, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM6P1(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM6P1>(`${API_PATH}/progress/measure-specific-targets-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM6P1(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM6P1): Promise<[MeasureSpecificTargetsM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM6P1>(`${API_PATH}/progress/measure-specific-targets-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressMeasureSpecificTargetsM4P4(subjectId: string, contractId: string, applicationId: string): Promise<[MeasureSpecificTargetsM4P4 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<MeasureSpecificTargetsM4P4>(`${API_PATH}/progress/measure-specific-targets-m4-p4/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P4, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressMeasureSpecificTargetsM4P4(subjectId: string, contractId: string, applicationId: string, data: MeasureSpecificTargetsM4P4): Promise<[MeasureSpecificTargetsM4P4 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<MeasureSpecificTargetsM4P4>(`${API_PATH}/progress/measure-specific-targets-m4-p4/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(MeasureSpecificTargetsM4P4, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getProgressFinalRemarks(subjectId: string, contractId: string, applicationId: string): Promise<[FinalRemarks | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<FinalRemarks>(`${API_PATH}/progress/final-remarks/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(FinalRemarks, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setProgressFinalRemarks(subjectId: string, contractId: string, applicationId: string, data: FinalRemarks): Promise<[FinalRemarks | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<FinalRemarks>(`${API_PATH}/progress/final-remarks/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(FinalRemarks, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

}
